// extracted by mini-css-extract-plugin
module.exports =  {"ellipsis":"ring-global-ellipsis","link":"BreadcrumbsLink__link--a3 ring-global-ellipsis","rightIcon":"BreadcrumbsLink__rightIcon--py"};